const SDK_VERSION = '7.112.2';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
